import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';

interface BreadcrumbProps {
  orderRef: string;
}

const BreadcrumbComponent: FC<BreadcrumbProps> = ({ orderRef }) => {
  const { t } = useTranslation('crmModule');

  const breadcrumbs = useMemo(
    () => [
      { label: t('breadcrumb.crm', 'CRM'), path: '/orders/crm' },
      { label: t('breadcrumb.orders', 'Órdenes'), path: '/orders/crm' },
      { label: orderRef },
    ],
    [t, orderRef],
  );

  usePageNavigation({ breadcrumbs });

  // Este componente no renderiza nada, solo configura el breadcrumb
  return null;
};

BreadcrumbComponent.displayName = 'Breadcrumb';

export { BreadcrumbComponent as Breadcrumb };
